import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { Page } from 'src/components/layouts/Page'
import { DonateForm } from 'src/components/organisms/forms/DonateForm'

import { NotFound } from 'src/pages/404/404'
import { NavigationContext } from 'src/types/account'
import { withAccountRequired } from 'src/utils/auth'
import { trpc } from 'src/utils/trpc'

const RegistryGift: NextPage = () => {
  const router = useRouter()

  const { registryUri } = router.query as {
    registryUri: string
  }

  const { data: registryData, isLoading } = trpc.useQuery([
    'registries.getByUri',
    { uri: registryUri }
  ])

  // Redirect if registry not found
  if (!registryData) return isLoading ? null : <NotFound />

  const { registry } = registryData
  const { Id, Name, IsCampaign } = registry

  return (
    <Page
      title={Name || 'Tree registry'}
      metaTitle={Name || 'Tree registry'}
      metaDescription='Something about funding trees for a registry'
      image='/forms/funding-tree-bg.svg'
      showBreadcrumbs={!IsCampaign}
      navigationContext={NavigationContext.Public}
    >
      <div className='max-w-3xl! mx-auto row'>
        <DonateForm registryId={Id} />
      </div>
    </Page>
  )
}

export default withAccountRequired(RegistryGift)
